module.exports = __webpack_public_path__ + "img/Device-Related.b26de2dd.svg";